module.exports = __webpack_public_path__ + "static/media/banner.e1d6730a.png";